import { render, staticRenderFns } from "./CopyFilters.vue?vue&type=template&id=38c096c4&scoped=true"
import script from "./CopyFilters.vue?vue&type=script&lang=js"
export * from "./CopyFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c096c4",
  null
  
)

export default component.exports